import React, { useEffect, useState } from "react";
import "./ReportScreen.css";
import {
  Button,
  Input,
  CircularProgress,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Select,
} from "@mui/material";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS } from "chart.js/auto";
import SideBar from "../SideBar/SideBar";
import axiosApiInstance from "../axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Multiselect from 'multiselect-react-dropdown';
import AllTicketsHeader from '../AllTickets/AllTicketsHeader';

const ReportScreen = () => {
  const [interval, setinterval] = useState([]);
  const [intervalId, setIntervalId] = useState("");
  const [bucketlId, setBucketId] = useState("");
  const [bucket, setBucket] = useState([]);
  const [typeId, setTypeId] = useState([]);
  const [type, setType] = useState('');
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [typeList, setTypeList] = useState([]);
  const [selectedValues, setSelectedValues] = useState([]);
  const [isRequiredLabelShown, setIsRequiredLabelShown] = useState(false);
  const [isInValidDate, setIsInValidDate] = useState(false);
  const [selectedChart, setSelectedChart] = useState(0);
  const [chartObjectKeys, setChartObjectKeys] = useState([]);
  const [graphLoader, setGraphLoaded] = useState(false);
  const [graphData, setGraphData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  const [chartData, setChartData] = useState({
    datasets: [
      {
        label: "Report 1",
        data: [],
      },
    ],
    labels: [],
  });

  const [chartDataTotal, setChartDataTotal] = useState({
    datasets: [
      {
        label: "Report 1",
        data: [],
      },
    ],
    labels: [],
  });

  useEffect(() => {
    if (graphData.length > 0 && selectedChart >= 0) {
      const label = [];
      const openedList = [];
      const closedList = [];
      const reOpenedList = [];
      const inProgressList = [];
      const workCompletedList = [];
      for (let i of graphData[selectedChart].bucket) {
        label.push(i.interval);
        openedList.push(i.opened);
        closedList.push(i.closed);
        reOpenedList.push(i.reOpened);
        inProgressList.push(i.inProgress);
        workCompletedList.push(i.workCompleted);
      }
      setChartData({
        datasets: [
          {
            label: "Opened",
            data: openedList,
            backgroundColor: ["#F0754D"],
          },
          {
            label: "Closed",
            data: closedList,
            backgroundColor: ["#0A387D"],
          },
          {
            label: "Reopened",
            data: reOpenedList,
            backgroundColor: ["#0F3523"],
          },
          {
            label: "Inprogress",
            data: inProgressList,
            backgroundColor: ["#F4163D"],
          },
          {
            label: "Work Completed",
            data: workCompletedList,
            backgroundColor: ["#049A03"],
          },
        ],
        labels: label,
      });
    }
  }, [selectedChart, graphData]);

  useEffect(() => {
    setSelectedValues([]);
    setTypeId([]);
    if (type === 'Priority') {
      axiosApiInstance.get(`/priority`)
        .then(resp => {
          setTypeList(resp.data.data);
        });
    } else if (type === 'User') {
      axiosApiInstance.get(`/assign`)
        .then(req => {
          let assignItem = [];
          let resData;
          resData = req.data.data
          for (let i = 0; i < resData.length; i++) {
            let idItem = resData[i].id;
            let data = resData[i].fullName;
            assignItem.push({ id: idItem, name: data })
          }
          setTypeList(assignItem);
        })
    } else {
      setTypeList([]);
    }
  }, [type]);

  useEffect(() => {
    let assignItem = [];

    for (let i = 1; i <= 10; i++) {
      let idItem = i;
      assignItem.push({ value: idItem });
    }
    setinterval(assignItem);
    setBucket(assignItem);
  }, []);

  const handleChange = (e) => {
    setIntervalId(e.target.value);
  };

  const handleBucket = (e) => {
    setBucketId(e.target.value);
  };
  const handleType = (e) => {
    setType(e.target.value);
  };

  const handleStart = (date) => {
    setStartDate(date);
  };

  const handleEnd = (date) => {
    setEndDate(date);
  };

  useEffect(() => {
    if (intervalId !== "" && bucketlId !== "" && type !== "" && typeId.length !== 0) {
      setIsRequiredLabelShown(false);
    }
    if (startDate < endDate) {
      setIsInValidDate(false);
    }
  }, [intervalId, bucketlId, type, typeId, startDate, endDate])

  const reportSubmit = () => {
    if (intervalId === "" || bucketlId === "" || type === "" || typeId.length === 0) {
      setIsRequiredLabelShown(true);
      setIsInValidDate(false);
    } else if (startDate >= endDate) {
      setIsInValidDate(true);
    } else {
      startDate.setUTCHours(0, 0, 0, 0);
      endDate.setUTCHours(0, 0, 0, 0);
      let data = JSON.stringify({
        interval: intervalId,
        noOfBuckets: bucketlId,
        type: type,
        typeId: typeId,
        startDate: startDate,
        endDate: endDate,
      });

      let endPoint = "/reports/AgingReportBasedOnType";

      axiosApiInstance.post(endPoint, data).then(function (response) {
        if (response?.data?.succeeded) {
          if (response?.data?.data?.length > 1) {
            setGraphLoaded(true);
            setGraphData(response?.data?.data);
            let filteredArray = response?.data?.data?.map(item => item.type);
            filteredArray.pop();
            setChartObjectKeys(filteredArray);

            const label = [];
            const openedList = [];
            const closedList = [];
            const reOpenedList = [];
            const inProgressList = [];
            const workCompletedList = [];
            for (let i of response?.data?.data[response?.data?.data?.length - 1]?.bucket) {
              label.push(i.interval);
              openedList.push(i.opened);
              closedList.push(i.closed);
              reOpenedList.push(i.reOpened);
              inProgressList.push(i.inProgress);
              workCompletedList.push(i.workCompleted);
            }
            setChartDataTotal({
              datasets: [
                {
                  label: "Opened",
                  data: openedList,
                  backgroundColor: ["#F0754D"],
                },
                {
                  label: "Closed",
                  data: closedList,
                  backgroundColor: ["#0A387D"],
                },
                {
                  label: "Reopened",
                  data: reOpenedList,
                  backgroundColor: ["#0F3523"],
                },
                {
                  label: "Inprogress",
                  data: inProgressList,
                  backgroundColor: ["#F4163D"],
                },
                {
                  label: "Work Completed",
                  data: workCompletedList,
                  backgroundColor: ["#049A03"],
                },
              ],
              labels: label,
            });
          } else {
            setGraphLoaded(false);
          }
        }
      });
    }
  };

  const onSelectAndRemoveTypeId = e => {
    let filteredIds = Array.isArray(e) ? e.map(x => x.id) : [];
    setTypeId(filteredIds);
    setSelectedValues(e);
  };

  const searchHandler = (searchTerm) => {
    setSearchTerm(searchTerm)
  }

  return (
    <>
      <AllTicketsHeader searchKeyword={searchHandler} term={searchTerm} />
      <SideBar />
      <div className="report-screen">
        <div className="status-bar-container">
          <div className="status-bar">
            <div>
              <FormControl variant="standard" sx={{ m: 1, minWidth: 100 }}>
                <InputLabel id="demo-simple-select-standard-label">
                  Interval <label className="required-field">*</label>
                </InputLabel>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  value={intervalId}
                  label="Interval"
                  onChange={handleChange}
                >
                  {interval.map((int, id) => (
                    <MenuItem key={id} value={int.value}>
                      {int.value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>

            <div>
              <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                <InputLabel id="demo-simple-select-standard-label">
                  No. of bucket <label className="required-field">*</label>
                </InputLabel>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  type="number"
                  label="NoofBucket"
                  value={bucketlId}
                  onChange={handleBucket}
                >
                  {bucket.map((int, id) => (
                    <MenuItem key={id} value={int.value}>
                      {int.value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>

            <div>
              <FormControl variant="standard" sx={{ m: 1, minWidth: 100 }}>
                <InputLabel id="demo-simple-select-standard-label">
                  Type <label className="required-field">*</label>
                </InputLabel>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  value={type}
                  label="ReportType"
                  onChange={handleType}
                >
                  <MenuItem value="Priority">
                    Priority
                  </MenuItem>
                  <MenuItem value="User">
                    User
                  </MenuItem>
                </Select>
              </FormControl>
            </div>

            <div>
            <FormControl variant="standard" sx={{ m: 1, minWidth: 100 }}>
              <InputLabel id="demo-simple-select-standard-label">
              <label className="required-field"></label>
              </InputLabel>
              <Multiselect
                className="report-multiselect"
                displayValue="name"
                placeholder="Select"
                options={typeList}
                selectedValues={selectedValues}
                selectionLimit={5}
                onSelect={e => onSelectAndRemoveTypeId(e)}
                onRemove={e => onSelectAndRemoveTypeId(e)}
                style={{
                  multiselectContainer: {
                    border: "1px solid #fff", // Use proper hex color code, and no `!important`
                  },
                  searchWrapper: {
                    border: "1px solid rgba(0, 0, 0, 0.42)", // Example border for the search box
                  }
                }}
              />
            </FormControl>
            </div>

            <div className="report-date">
            <InputLabel id="demo-simple-select-standard-label">
              <label className="lab-datetime">Start date</label>
            </InputLabel>
              <DatePicker
                className="report-date-picker"
                selected={startDate}
                onChange={handleStart}
                dateFormat="MM-dd-yyyy"
              />
            </div>

            <div className="report-date">
            <InputLabel id="demo-simple-select-standard-label">
              <label className="lab-datetime">End date</label>
            </InputLabel>
              <DatePicker
                className="report-date-picker"
                selected={endDate}
                onChange={handleEnd}
                dateFormat="MM-dd-yyyy"
              />
            </div>
            <Button
              tyoe="submit"
              className="report-save-btn"
              onClick={reportSubmit}
            >
              Submit
            </Button>
          </div>
          {isRequiredLabelShown &&
            <div className="required-field-container">
              <label className="required-field-label">* Please fill all the required fields</label>
            </div>}
          {isInValidDate &&
            <div className="required-field-container">
              <label className="required-field-label">* End date must be greater than Start date</label>
            </div>}
        </div>

        {graphLoader && <div className="chart-container">
          <div className="chart1-container">
            <div className="radio-group-container">
              <RadioGroup className="radio-buttons-container" row aria-label="priority" name="row-radio-buttons-group" value={selectedChart} onChange={(e) => {
                setSelectedChart(e.target.value);
              }}>
                {chartObjectKeys?.map((item, index) => (
                  <FormControlLabel value={index} control={<Radio />} label={item} className="radio-button-label" />
                ))}
              </RadioGroup>
            </div>
            <div className="chart1">
              <Bar data={chartData} />
              <label className="x-axis-title">
                Bucket Interval
              </label>
              <div className="y-axis-title-container">
                <label className="y-axis-title">
                  Ticket Status Count
                </label>
              </div>
            </div>
          </div>
          <div className="chart2-container">
            <div className="chart2">
              <Bar data={chartDataTotal} />
              <label className="x-axis-title">
                Bucket Interval
              </label>
              <div className="y-axis-title-container">
                <label className="y-axis-title">
                  Ticket Status Count
                </label>
              </div>
            </div>
          </div>
        </div>}
      </div>
    </>
  );
};

export default ReportScreen;
